import React from 'react';
import ProjectContext from 'contexts/ProjectContext';
import {useProject} from 'hooks/projects/queries';
import { useCurrentProject } from 'hooks/projects/useCurrentProject';
import { useHasEditPermission } from 'hooks/users/useHasEditPermission';
import { useProjectCacheReset } from 'hooks/projects/useProjectCacheReset';

const ProjectInfoWrapper = ({ projectID, children }) => {
  const currentProject = useCurrentProject();
  const resolvedProjectID = currentProject.projectId || projectID;

  useProjectCacheReset(resolvedProjectID);

  const { data: project } = useProject(resolvedProjectID);
  const hasEditPermission = useHasEditPermission(project);

  return (
    <ProjectContext.Provider
      value={{
        project: project
      }}
    >
      <div>
        {React.cloneElement(children, {
          project: project,
          projectID: resolvedProjectID,
          hasEditPermission,
        })}
      </div>
    </ProjectContext.Provider>
  );
};

export default ProjectInfoWrapper;
